export default {
    getMenu(state) {
        return state.menu;
    },
    isMenuOpened(state) {
        return !!state.menuOpened;
    },


}